import React from 'react';
import { Components } from '../../types';
import { InnerMenuItem } from './InnerMenuItem';

export const Option: NonNullable<Components['Option']> = (props) => (
  <InnerMenuItem
    option={props.option}
    dataTest={props.dataTest}
    searchTerm={props.searchTerm}
    noWrapSubLabel={props?.noWrapSubLabel}
  />
);
